var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.365.734C3.518.33 2.335.132.75.125A.735.735 0 00.087.52.75.75 0 000 .873v6.705c0 .453.323.795.75.795 1.666 0 3.337.156 4.337 1.102a.096.096 0 00.163-.07V1.504a.372.372 0 00-.128-.282 3.351 3.351 0 00-.757-.488zM10.92.25a.734.734 0 00-.42-.124C8.915.132 7.732.33 6.885.735a3.359 3.359 0 00-.757.486.373.373 0 00-.128.282v7.901a.092.092 0 00.157.066c.601-.598 1.657-1.097 4.344-1.097a.75.75 0 00.75-.75V.873a.749.749 0 00-.331-.624z",
    fill: "#E07B3C"
  })));
}

export default SvgIconBook;